import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
// import { Checkbox, CheckboxGroup } from 'rsuite';
import { IconButton, Message, Panel, Row, Icon } from 'rsuite'
// import ThePoint from './ThePoint'
import CheckboxColForm from '../../../components/forms/checkboxColForm/CheckboxColForm'
import CheckboxColView from '../../../components/forms/checkboxColForm/CheckboxColView'
import scrollToComponent from 'react-scroll-to-component'
import { Controller, useForm } from 'react-hook-form'
import {
  updateSubProjectTargetIssues,
  updateTargetIssues,
} from '../../../redux/actions/targetSetting'
import { doneLoading, startLoading } from '../../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import { saveConfirmActualResult } from '../../../redux/actions/closeOfProject'

export default function ThePointWidget(props) {
  const {
    showCommandButton,
    schema,
    checked,
    isConfirmActualResult = false,
    isEdit,
    onChangeIsEdit,
    isSubProject,
    numberOfInstallment,
    onSuccess = () => {},
  } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const { register, handleSubmit, watch, errors, control, setValue, clearErrors, getValues } =
    useForm()

  const [formSchema, setFormSchema] = useState(schema)

  const handleUpdateTargetIssues = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await updateTargetIssues(projectId, request)
      if (response.success) {
        setFormSchema(response.model)
        onChangeIsEdit(false)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpdateTargetIssuesSubProject = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await updateSubProjectTargetIssues(projectId, request)
      // console.log('res => ', response)
      // subproject ไม่มี response.success ส่งกลับมา เหมือนโครงการหลัก
      if (response) {
        setFormSchema(response)
        onChangeIsEdit(false)
        await dispatch(getSchemaSubProjectSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let selected = data.issuesSelected
    const index = selected?.indexOf('OTHER')
    if (index > -1) {
      selected.splice(index, 1)
    }

    let request = {
      optionSelected: selected,
      inputOther: data.inputOther || '',
    }

    console.log('request ', request)

    if (isSubProject) {
      handleUpdateTargetIssuesSubProject(request)
    } else {
      handleUpdateTargetIssues(request)
    }
  }

  const onSubmitConfActualResult = (data) => {
    console.log('onSubmitConfActualResult => ', data)

    let selected = data?.issuesSelected?.map((v) => (v === 'OTHER' ? '9999' : v))
    // const index = selected?.indexOf('OTHER')
    // if (index > -1) {
    //   selected.splice(index, 1)
    // }

    // let request = {
    //   optionSelected: selected,
    //   inputOther: data.inputOther || '',
    // }

    let request = {
      optionSelected: selected,
      inputOther: data.inputOther,
      confType: 'TargetIssues',
      targetLists: null,
      numberOfInstallment: numberOfInstallment,
      inputCriteria: null,
      year: null,
      version: null,
    }

    console.log('request => ', request)
    handleSaveConfirmActualResult(request)
  }

  const handleSaveConfirmActualResult = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await saveConfirmActualResult(projectId, request)
      console.log('response : ', response)
      if (response.success) {
        onSuccess(true)

        // const saveResp = await getCloseOfProjectCoworkerForm(projectId)
        //
        // let _formSchema = cloneDeep(formSchema)
        //
        // _formSchema.optionSelected = saveResp?.forms?.confirmActualResul?.goal?.goalTenYear?.optionSelected || null
        //
        // setCheckedConf(saveResp?.forms?.confirmActualResulChecked?.goalTenYearChecked || null)
        // setFormSchema(_formSchema)

        // await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
        onSuccess(false)
      }
    } catch (e) {
      setIsError(true)
      onSuccess(false)
    }

    setIsLoading(false)
    doneLoading()
  }

  const checkboxColForm = (
    <CheckboxColForm
      schema={formSchema.issues}
      register={register}
      Controller={Controller}
      control={control}
      errors={errors}
      setValue={setValue}
      clearErrors={clearErrors}
      getValues={getValues}
      column={3}
    />
  )

  const checkboxColView = <CheckboxColView schema={formSchema.issues} column={3} />

  return (
    <Panel
      shaded={!isConfirmActualResult}
      bordered={!!isConfirmActualResult}
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? checkboxColForm : checkboxColView}

      {showCommandButton && (
        <>
          <hr />

          {isEdit ? (
            <div>
              {isError && (
                <Row style={{ marginBottom: '1em' }}>
                  <Message
                    showIcon
                    type="error"
                    description={
                      'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                    }
                  />
                </Row>
              )}

              {isConfirmActualResult ? (
                <>
                  {checked && (
                    <Message
                      showIcon
                      type={checked.checkedType ? 'success' : 'error'}
                      description={
                        <div dangerouslySetInnerHTML={{ __html: checked.detail || '' }} />
                      }
                      style={{ marginBottom: 10 }}
                    />
                  )}

                  <SaveButton
                    icon="views-authorize"
                    onClick={handleSubmit(onSubmitConfActualResult)}
                    // disabled={!!checked?.checkedType || isLoading}
                    disabled={isLoading}
                    children={'ยืนยันการดำเนินการจริง'}
                  />
                </>
              ) : (
                <>
                  <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}></SaveButton>
                  <CancelButton
                    onClick={() => {
                      onChangeIsEdit(!isEdit)
                      setIsError(false)
                    }}
                    disabled={isLoading}
                  ></CancelButton>
                </>
              )}
            </div>
          ) : (
            <>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-edit"
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
              >
                แก้ไข{formSchema.header}
              </IconButton>

              {/*<EditButton*/}
              {/*  onClick={() => {*/}
              {/*    onChangeIsEdit(!isEdit)*/}
              {/*    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })*/}
              {/*  }}*/}
              {/*>*/}
              {/*  แก้ไข{formSchema.header}*/}
              {/*</EditButton>*/}
            </>
          )}
        </>
      )}
    </Panel>
  )
}

// const formSchemas = {
//   header: 'ประเด็น',
//   issues: {
//     name: 'issuesSelected',
//     alert: 'เลือกได้มากกว่า 1 ข้อ',
//     selectAllCheckbox: true,
//     optionSelected: [1, 2],
//     options: [
//       {
//         name: 'checkbox1',
//         value: 1,
//         label: '1. สุขภาพจิต',
//       },
//       {
//         name: 'checkbox2',
//         value: 2,
//         label: '2. กิจกรรมทางกาย',
//       },
//       {
//         name: 'checkbox3',
//         value: 3,
//         label: '3. ยาสูบ',
//       },
//       {
//         name: 'checkbox4',
//         value: 4,
//         label: '4. อาหาร',
//       },
//       {
//         name: 'checkbox5',
//         value: 5,
//         label: '5.  แอลกอฮอล์',
//       },
//       {
//         name: 'checkbox6',
//         value: 6,
//         label: '6. สารเสพติด',
//       },
//       {
//         name: 'checkbox7',
//         value: 7,
//         label: '7. อุบัติเหตุ',
//       },
//       {
//         name: 'checkbox8',
//         value: 8,
//         label: '8. สุขภาวะทางเพศ',
//       },
//       {
//         name: 'checkbox9',
//         value: 9,
//         label: '9. สิ่งแวดล้อม',
//       },
//       {
//         name: 'checkbox10',
//         value: 10,
//         label: '10. การป้องกันโรค เช่น การให้วัคซีน',
//       },
//       {
//         name: 'checkbox11',
//         value: 11,
//         label: '11. สุขภาวะครอบครัว',
//       },
//       {
//         name: 'checkbox12',
//         value: 12,
//         label: '12. การคุ้มครองผู้บริโภค',
//       },
//       {
//         name: 'checkbox13',
//         value: 13,
//         label: '13. ความไม่เท่าเทียมด้านสุขภาพ',
//       },
//       {
//         name: 'checkbox14',
//         value: 14,
//         label: '14. ภัยพิบัติ',
//       },
//       {
//         name: 'checkbox15',
//         value: 15,
//         label: '15. ภัยพิบัติ',
//       },
//       {
//         name: 'checkbox16',
//         value: 16,
//         label: '16. สุขภาวะชุมชน',
//       },
//       {
//         name: 'checkbox17',
//         value: 17,
//         label: '17. ระบบสุขภาพ',
//       },
//       {
//         name: 'checkbox18',
//         value: 18,
//         label: '18. สุขภาวะองค์กร',
//       },
//       {
//         name: 'checkbox19',
//         value: 19,
//         label: '19. สุขภาวะทางปัญญา',
//       },
//       {
//         name: 'checkbox20',
//         value: 20,
//         label: '20. การศึกษา',
//       },
//       {
//         name: 'checkbox21',
//         value: 21,
//         label: '21. อื่น ๆ',
//       },
//     ],
//     validators: [
//       {
//         type: 'REQUIRED',
//         errorMessage: 'กรุณาเลือก อย่างน้อย 1 รายการ',
//       },
//     ],
//     inputOther: {
//       name: 'inputOther',
//       value: '',
//       label: 'โปรดระบุ',
//     },
//   },
// }
